/** Costo en USD de cada mensaje de WhatsApp enviado. */
export const MESSAGE_COST_USD: number = 0.053;

/** Gasto total en USD dado un número de mensajes enviados. */
export const messagingSpend = (sentCount: number): number =>
  sentCount * MESSAGE_COST_USD;
